//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList } from '@api/api';
import pick from 'lodash.pick';
import moment from 'moment';
import SelectAssetModal from "../../SelectAssetModal";
import IwsUpload from '@comp/upload/IwsUpload';
import { httpAction } from '@/api/manage';
export default {
  name: 'AssetsMaintainModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    SelectAssetModal: SelectAssetModal,
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '设备保养表单',
      tableName: 'ea_assets_maintain',
      form_fields: ['siteId', 'productName', 'code', 'description', 'category', 'fee', 'outService', 'companyId', 'deptId', 'userId', 'remark', 'tenantId'],
      form_fields_time: ['maintainDate'],
      validatorRules: {
        category: {
          rules: [{
            required: true,
            message: '请选择保养类别!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择责任人!'
          }]
        },
        maintainDate: {
          rules: [{
            required: true,
            message: '请选择保养时间!'
          }]
        },
        productName: {
          rules: [{
            required: true,
            message: '请选择设备资产!'
          }]
        }
      },
      siteName: '',
      // 人员信息
      userTree: []
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('this.model', this.model);
      this.visible = true;
      this.selectedAsset = [];
      this.userTree = [];

      if (this.model.id) {
        this.siteName = this.model.siteName;
        this.model.assetId = this.model.assetId ? this.model.assetId : null;
        this.productName = this.model.productName ? this.model.productName : null;
      }

      this.loadTreeList();
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        that.form.setFieldsValue({
          maintainDate: _this.model.maintainDate ? moment(_this.model.maintainDate) : null
        });
        that.$refs.iwupload.loadUploadFiles();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.maintainDate = formData.maintainDate ? formData.maintainDate.format('YYYY-MM-DD') : null; // formData.assetId = that.assetIds == [] ? null : that.assetIds
          // if (typeof that.assetIds == 'object') {
          //   if (that.assetIds.length < 1) {
          //     this.$message.warning('请选择设备')
          //     that.confirmLoading = false
          //     return
          //   }
          // }

          formData.siteId = formData.siteId ? formData.siteId : _this2.currentSiteId;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this3 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    },
    selectAssets: function selectAssets() {
      this.$refs.AssetListModal.siteId = this.currentSiteId;
      this.$refs.AssetListModal.disableSubmit = true;
      this.$refs.AssetListModal.add(this.selectedAsset, this.assetId);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      console.log('productList', productList);
      this.model.assetId = productList[0].id;
      this.form.setFieldsValue({
        productName: productList[0].productName
      });
    }
  }
};